import React from 'react';
import SystemArchitecture from '../components/SystemArchitecture';

const SystemArchitecturePage: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        background: '#1a1a1a',
      }}
    >
      <main
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          padding: '20px',
        }}
      >
        <SystemArchitecture />
      </main>
    </div>
  );
};

export default SystemArchitecturePage;
